import './style/login.css';
import React, { useState } from 'react'
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import './userafterlogin'

import Header from './header';
import Footer from './footer';
// import { getDefaultNormalizer } from '@testing-library/dom';


const Signin = (props) => {
  
  let history = useHistory()

  const [uemail, setEmail] = useState("");
  const [upass, setPass] = useState("");;
  const [msg, setMessage] = useState("");;

  const onChangeEmail = (e) => setEmail(e.target.value);
  const onChangePass = (e) => setPass(e.target.value);

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    console.log(`EMAIL: ${uemail}`);
    console.log(`PASS: ${upass}`);

    const logininfo = {
      empemail: uemail.toLowerCase(),
      emppass: upass
    }

    console.log()

    if ((uemail.toLowerCase() === "admin@bikerental.com" || uemail.toLowerCase() === "bikerental@gmail.com" || uemail.toLowerCase() ==="admin@gmail.com" ) && (upass === "admin" || upass === "bikerental")) {
      sessionStorage.setItem("Key_Veriable", 'ADMIN')
      setMessage('WELCOME ADMIN')
      history.push('/adminafterlogin')
    }
	else
	{
    axios.post('https://akshatngupta-bike-rental.herokuapp.com/user/logincheck', logininfo)
      .then(res => {
        console.log(res.data)
        sessionStorage.setItem("Key_Veriable", 'USER')
        sessionStorage.setItem("email", res.data.email)
        sessionStorage.setItem("name", res.data.name)
        history.push('/userafterlogin')
        // <Link to="/signup"></Link>
      })
      .catch(err => {
        console.log(err)
        setMessage('INVALID USER ID OR PASSWORD')
      })
	}
    setEmail('')
    setPass('')
  }

  
  return (
      <div id={'in'}>
       <Header />
    <div className='main'>
        <div className='container'>
            <div className='bike-container'>
                <div className='bg-color'>
                    <div className='bike'>
                        <img src={require(`../assets/duke.png`)} alt='' />
                    </div>
                    <div className="myform4">
                    <div className="shifter">
                    <form onSubmit={handleSubmit} >
                            <b><h3>Login</h3></b>
                            <b style={{ color: "brown" }}> {msg}</b>
							              <p><label>Email</label></p>
							              <input type="email" className="form-control" value={uemail} onChange={onChangeEmail} placeholder="Enter Email"  required/>
                            <label>Password</label>
                            <input type="password" className="form-control" placeholder="Enter password" value={upass} onChange={onChangePass}  required/>	
                            <input type="checkbox" className="custom-control-input" id="customCheck1" />
                            <p><input type="checkbox"/><label >Remember Me</label></p>
                            <button  className="Button5" type="submit" value="LOGIN">Login</button>
                            <p>Forgot Password?.<Link to="./forgot_password"><a >forgot password </a></Link></p>
                            <p className="forgot-password text-center">
                            Or Sign up and start your journey<Link to="/signin"> <a>SignUp</a></Link>
						</p>
                            {/* <Link to="/signup"><button className='Button3' ></button></Link> */}
                            {/* <label>Or sign in with:</label>
                            <a href="www.fb.com" id="facebookIcon">.</a>
                            <a href="www.twitter.com" id="twitterIcon">.</a>
                            <a href="www.google.com" id="googleIcon">.</a> */}
					      </form>
                    </div>  
                    </div>
            </div>
            </div>
        </div>
    </div>
    <Footer />
    </div>
  );
};
export default Signin;